var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlazemeter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D12429;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,41.4c-11.9,0-23.9,0-35.8,0c-2.8,0-5.9-0.2-5.8-3.7c0.1-3.3,3.1-3.6,6-3.5c24.2,0,48.4,0,72.6,0 c2.4,0,5.6-0.6,5.6,3c0,3.4-2.6,4.2-5.8,4.2C84.5,41.3,72.2,41.4,60,41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.3,20c7.3,0,14.5,0,21.8,0c2.8,0,5.7,0.3,5.5,3.9c-0.1,3.2-3,3.6-5.5,3.6c-14.5,0.1-29.1,0.1-43.6,0 c-2.7,0-5.7-0.3-5.5-4c0.2-3.3,2.8-3.5,5.4-3.5C69.7,20,77,20,84.3,20C84.3,20,84.3,20,84.3,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.5,48.1c7.1,0,14.2,0,21.4,0c2.9,0,5.8,0.4,5.8,3.7c0,3.1-2.8,3.6-5.4,3.6c-14.4,0-28.8,0-43.2,0 c-2.6,0-5.5-0.2-5.5-3.5c0-3.4,2.6-3.9,5.6-3.8C48.3,48.2,55.4,48.1,62.5,48.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.2,62.7c3,0,5.9,0.1,8.9,0c2.7-0.1,4.1,1.4,4.2,3.7c0.1,2.2-1.3,3.6-3.8,3.6c-6.3,0-12.5,0-18.8,0 c-2.4,0-3.8-1.4-3.7-3.6c0.1-2.1,1.2-3.7,3.8-3.6C75.9,62.8,79,62.8,82.2,62.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlazemeter);
export default __webpack_public_path__ + "static/media/Blazemeter.021f5b0bd5fee16692bbd0f153fc8033.svg";
export { ForwardRef as ReactComponent };